import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { PriceSettings } from "./priceSettingsApi";
import { getPriceSettings, updatePriceSettings } from "./priceSettingsApi";

export const usePriceSettings = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["global-settings", "prices"],
    queryFn: ({ signal }) => getPriceSettings(signal),
  });

  const updateMutation = useMutation<PriceSettings, unknown, PriceSettings>({
    mutationFn: (v) => updatePriceSettings(v),
    onSuccess: async (data) => {
      enqueueSnackbar("Ustawienia cen zostały zaktualizowane", { variant: "success" });
      queryClient.setQueryData(["global-settings", "prices"], data);
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zaktualizować ustawień cen. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return { isLoading, data, updateSettings: (settings: PriceSettings) => updateMutation.mutateAsync(settings) };
};
